import { LeaveApplicationListTable } from '../components/LeaveApplicationListTable';

export function LeaveApplicationListPage() {
  return <LeaveApplicationListTable />;
}
